import { loadLocale } from './Locale';
import { createScript } from './Scripts/scripts';
import { ROYAL_BRANDCODE, CELEBRITY_BRANDCODE } from './Scripts/constants';
import { loadDictionaries } from './Dictionary';
export {
  loadLocale,
  createScript,
  loadDictionaries,
  ROYAL_BRANDCODE,
  CELEBRITY_BRANDCODE,
};
